/*
  VEKTRA · Página de producto
  Variantes, galería con barrido, barra fija de compra, descripción plegable
  y la tarjeta animada de envío (detecta ENVÍO GRATIS/INCLUIDO, FAST, nota y Entrega estimada en la descripción).
*/
(function () {
  'use strict';

  var T = window.vkTheme || { strings: {} };
  var S = T.strings || {};

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function money(cents) {
    return window.vkUI ? window.vkUI.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  /* ================= Tarjeta de envío ================= */
  var RE_EMOJIS = /(\u{1F69A}|\u{26A1}|\u{1F680}|\u{1F4E6}|\u{1F4C5}|\u{1F4C6}|\u{23F1}|\u{23F3}|\u{231B})️?/gu;
  var RE_ENVIO = /\benvios?\s*(gratis|gratuito|incluido)\b|\bfree\s*shipping\b/;
  var RE_FAST = /\bfast\b/;
  var RE_FAST_SOLO = /^(envio |entrega )?fast( shipping| delivery)?$/;
  var RE_ENTREGA = /\b(entrega|llegada)\s*estimada\b/;
  var RE_NOTA = /costo del? envio.*incluido|no pagaras.*(cargo|costo).*envio/;

  var ICON_TRUCK = '<svg class="vk-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h12v10H2zM14 9.5h4.2L21 13v3h-7"/><circle cx="6" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>';
  var ICON_BOLT = '<svg class="vk-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 2L4 14h7l-1.5 8L20 9.5h-7z"/></svg>';
  var ICON_CAL = '<svg class="vk-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 5.5h17v15h-17zM3.5 10h17M8 3v5M16 3v5"/></svg>';

  function norm(s) {
    return (s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[​-‍﻿]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function soloLetras(s) {
    return s.replace(/[^a-z ]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function vacio(el) {
    return norm(el.textContent) === '' && !(el.querySelector && el.querySelector('img, video, iframe'));
  }

  function limpiarHtml(el) {
    return el.innerHTML.replace(RE_EMOJIS, '').replace(/^(\s|&nbsp;)+/, '').trim();
  }

  function calificar(el) {
    if (/^(SCRIPT|STYLE|SVG|IMG|BR|VIDEO|IFRAME|TABLE)$/i.test(el.tagName)) return null;
    if (el.querySelector('img, video, iframe, table')) return null;
    var t = norm(el.textContent);
    var envio = RE_ENVIO.test(t);
    var fast = RE_FAST.test(t);
    var entrega = RE_ENTREGA.test(t);
    var nota = RE_NOTA.test(t);
    if ((nota ? 1 : 0) + (entrega ? 1 : 0) + (envio || fast ? 1 : 0) > 1) return null;
    if (nota) return t.length <= 220 ? { tipo: 'nota' } : null;
    if (entrega) return t.length <= 160 ? { tipo: 'entrega' } : null;
    if (envio && t.length <= 60) return { tipo: 'cabecera', envio: true, fast: fast };
    if (fast && RE_FAST_SOLO.test(soloLetras(t))) return { tipo: 'cabecera', envio: false, fast: true };
    return null;
  }

  function separarSaltos(root) {
    $$('p, div, h2, h3, h4, h5, h6, li, span', root).forEach(function (el) {
      if (!el.querySelector(':scope > br')) return;
      var t = norm(el.textContent);
      if (!RE_ENVIO.test(t) && !RE_FAST.test(t) && !RE_ENTREGA.test(t) && !RE_NOTA.test(t)) return;
      var segmentos = [[]];
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeName === 'BR') segmentos.push([]);
        else segmentos[segmentos.length - 1].push(n);
      });
      el.innerHTML = '';
      segmentos.forEach(function (seg) {
        var linea = document.createElement('span');
        linea.style.display = 'block';
        seg.forEach(function (n) {
          linea.appendChild(n);
        });
        el.appendChild(linea);
      });
    });
  }

  function buscarLineas(root) {
    var lineas = [];
    $$('*', root).forEach(function (el) {
      if (lineas.some(function (l) {
        return l.el.contains(el);
      })) return;
      var info = calificar(el);
      if (info) lineas.push({ el: el, info: info });
    });
    return lineas;
  }

  function etiquetaEnvio(el, unify) {
    if (unify) return 'ENVÍO GRATIS';
    var t = norm(el.textContent);
    if (/incluido/.test(t)) return 'ENVÍO INCLUIDO';
    if (/gratuito/.test(t)) return 'ENVÍO GRATUITO';
    if (/free/.test(t)) return 'FREE SHIPPING';
    return 'ENVÍO GRATIS';
  }

  function buildShipping(container) {
    var slot = $('[data-vk-ship]', container);
    var desc = $('[data-vk-desc]', container);
    if (!slot || slot.dataset.ready) return;
    slot.dataset.ready = '1';
    var unify = slot.getAttribute('data-unify') === 'true';

    var envioEl = null;
    var hayFast = false;
    var notaEl = null;
    var entregaEl = null;
    var usados = [];

    if (desc) {
      separarSaltos(desc);
      // Sólo cuenta lo que aparece al inicio de la descripción (donde se escribe el envío)
      buscarLineas(desc).slice(0, 6).forEach(function (l) {
        if (l.info.tipo === 'entrega') {
          if (!entregaEl) {
            entregaEl = l.el;
            usados.push(l.el);
          }
        } else if (l.info.tipo === 'nota') {
          if (!notaEl) {
            notaEl = l.el;
            usados.push(l.el);
          }
        } else {
          if (l.info.envio && !envioEl) {
            envioEl = l.el;
            usados.push(l.el);
          }
          if (l.info.fast) {
            hayFast = true;
            if (usados.indexOf(l.el) === -1) usados.push(l.el);
          }
        }
      });
    }

    var html = '';
    if (envioEl || hayFast) {
      html += '<div class="vk-ship__top">';
      if (envioEl) html += '<span class="vk-ship__chip">' + ICON_TRUCK + '<span>' + etiquetaEnvio(envioEl, unify) + '</span></span>';
      if (hayFast) html += '<span class="vk-ship__fast">' + ICON_BOLT + '<span>FAST</span></span>';
      html += '</div>';
    }
    if (notaEl) html += '<div class="vk-ship__note">' + limpiarHtml(notaEl) + '</div>';
    if (entregaEl) {
      var eta = limpiarHtml(entregaEl).replace(/\(([^()]*%[^()]*)\)/, '<span class="vk-ship__prob">$1</span>');
      html += '<div class="vk-ship__eta">' + ICON_CAL + '<span>' + eta + '</span></div>';
    }

    if (!html && slot.getAttribute('data-fallback') === 'true') {
      html =
        '<div class="vk-ship__top"><span class="vk-ship__chip">' +
        ICON_TRUCK +
        '<span>' +
        (slot.getAttribute('data-fallback-title') || 'ENVÍO INCLUIDO') +
        '</span></span></div>' +
        '<div class="vk-ship__note" style="font-style:normal">' +
        (slot.getAttribute('data-fallback-text') || '') +
        '</div>';
    }

    if (!html) {
      slot.remove();
      return;
    }

    slot.innerHTML = html;
    slot.classList.remove('is-pending');

    // Quita de la descripción lo que ya se muestra en la tarjeta
    usados.forEach(function (el) {
      var padre = el.parentElement;
      el.remove();
      while (padre && padre !== desc && vacio(padre)) {
        var p = padre.parentElement;
        padre.remove();
        padre = p;
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            slot.classList.add('in-view');
            io.disconnect();
          }
        },
        { threshold: 0.4 }
      );
      io.observe(slot);
    } else {
      slot.classList.add('in-view');
    }
  }

  /* ================= Producto ================= */
  function Product(container) {
    this.el = container;
    this.quick = container.hasAttribute('data-quick');
    var data = $('script[data-vk-variants-json]', container);
    try {
      this.variants = JSON.parse(data ? data.textContent : '[]');
    } catch (e) {
      this.variants = [];
    }
    this.form = document.getElementById(container.getAttribute('data-form')) || $('[data-vk-product-form]', container);
    this.idInput = this.form ? $('[data-vk-variant-id]', this.form) : null;
    this.picker = $('div[data-vk-variants]', container);
    this.gallery = $('[data-vk-gallery]', container);
    this.bind();
  }

  Product.prototype.bind = function () {
    var self = this;
    if (this.picker) {
      this.picker.addEventListener('change', function (e) {
        if (e.target.matches('[data-vk-option]')) self.onOptionChange(e.target);
      });
      this.markAvailability();
    }
    $$('[data-vk-qty]', this.el).forEach(function (q) {
      var input = $('input', q);
      q.addEventListener('click', function (e) {
        var b = e.target.closest('[data-vk-qty-step]');
        if (!b) return;
        var step = parseInt(input.getAttribute('step'), 10) || 1;
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10) || Infinity;
        var v = (parseInt(input.value, 10) || min) + step * parseInt(b.getAttribute('data-vk-qty-step'), 10);
        input.value = Math.min(max, Math.max(min, v));
      });
    });
    if (this.gallery) this.initGallery();
    this.initDescription();
    buildShipping(this.el);
    if (!this.quick) this.initSticky();
  };

  Product.prototype.selectedValues = function () {
    var values = [];
    $$('[data-vk-option]', this.picker).forEach(function (input) {
      var i = parseInt(input.getAttribute('data-vk-option'), 10);
      if (input.type === 'radio') {
        if (input.checked) values[i] = input.value;
      } else {
        values[i] = input.value;
      }
    });
    return values;
  };

  Product.prototype.findVariant = function (values) {
    return (
      this.variants.filter(function (v) {
        return v.options.every(function (o, i) {
          return values[i] === undefined || o === values[i];
        });
      })[0] || null
    );
  };

  Product.prototype.markAvailability = function () {
    var self = this;
    var values = this.selectedValues();
    $$('fieldset[data-vk-option-group]', this.picker).forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-vk-option-group'), 10);
      $$('input[type="radio"]', fs).forEach(function (input) {
        var test = values.slice();
        test[idx] = input.value;
        var match = self.variants.some(function (v) {
          return (
            v.available &&
            v.options.every(function (o, i) {
              return test[i] === undefined || o === test[i];
            })
          );
        });
        input.classList.toggle('is-unavailable', !match);
      });
    });
  };

  Product.prototype.onOptionChange = function (input) {
    var fs = input.closest('fieldset');
    if (fs) {
      var label = $('[data-vk-option-label]', fs);
      if (label) label.textContent = input.getAttribute('data-label') || input.value;
    }
    var variant = this.findVariant(this.selectedValues());
    this.markAvailability();
    this.render(variant);
  };

  Product.prototype.render = function (variant) {
    var addBtn = this.form ? $('[data-vk-add]', this.form) : null;
    var addLabel = addBtn ? $('[data-vk-add-label]', addBtn) : null;
    var dynamic = this.form ? $('[data-vk-dynamic]', this.form) : null;
    var stock = $('[data-vk-stock]', this.el);
    var priceWrap = $('[data-vk-price-wrap] [data-vk-price]', this.el);
    var sticky = document.querySelector('[data-vk-sticky-buy]');

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = S.unavailable || 'No disponible';
      if (dynamic) dynamic.hidden = true;
      if (stock) {
        stock.textContent = S.unavailable || 'No disponible';
        stock.classList.add('vk-stock--out');
      }
      return;
    }

    if (this.idInput) this.idInput.value = variant.id;
    var termsForm = document.getElementById('vk-terms-form');
    if (termsForm && !this.quick) {
      var tid = $('input[name="id"]', termsForm);
      if (tid) tid.value = variant.id;
    }
    if (addBtn) addBtn.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? S.addToCart || 'Agregar al carrito' : S.soldOut || 'Agotado';
    if (dynamic) dynamic.hidden = !variant.available;
    if (stock) {
      stock.textContent = variant.available ? stock.getAttribute('data-in') || stock.textContent : S.soldOut || 'Agotado';
      stock.classList.toggle('vk-stock--out', !variant.available);
    }

    var priceHtml = this.priceHtml(variant);
    if (priceWrap) priceWrap.outerHTML = priceHtml.replace('<div class="vk-price"', '<div class="vk-price" data-vk-price');
    if (sticky && !this.quick) {
      var sp = $('[data-vk-sticky-price]', sticky);
      if (sp) sp.innerHTML = priceHtml;
      var sb = $('[data-vk-sticky-add]', sticky);
      if (sb) {
        sb.disabled = !variant.available;
        sb.textContent = variant.available ? S.addToCart || 'Agregar al carrito' : S.soldOut || 'Agotado';
      }
    }

    if (variant.featured_media && this.gallery) this.goToMedia(variant.featured_media.id);

    if (!this.quick && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  Product.prototype.priceHtml = function (v) {
    var html = '<div class="vk-price"><span class="vk-price__now">' + money(v.price) + '</span>';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var save = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
      html += '<s class="vk-price__compare">' + money(v.compare_at_price) + '</s>';
      html += '<span class="vk-price__save">−' + save + '%</span>';
    }
    return html + '</div>';
  };

  /* ---------- Galería ---------- */
  Product.prototype.initGallery = function () {
    var self = this;
    var g = this.gallery;
    this.track = $('[data-vk-gallery-track]', g);
    this.slides = $$('.vk-gallery__slide', g);
    this.thumbs = $$('[data-vk-thumb]', g);
    this.counter = $('[data-vk-gallery-current]', g);
    this.progress = $('[data-vk-gallery-progress]', g);
    this.index = 0;
    if (!this.track) return;

    var ticking = false;
    this.track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth));
          self.setActive(i);
        });
      },
      { passive: true }
    );

    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        self.goTo(parseInt(t.getAttribute('data-vk-thumb'), 10), true);
      });
    });
    this.initDrag();
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.goTo(Math.min(self.slides.length - 1, self.index + 1), true);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.goTo(Math.max(0, self.index - 1), true);
      }
    });
    g.addEventListener('click', function (e) {
      if (e.target.closest('[data-vk-zoom]')) self.openLightbox(self.index);
    });

    // Foto inicial: la primera, o la de la variante elegida en el enlace. Se coloca sin animación.
    var start = parseInt(g.getAttribute('data-vk-start'), 10) || 0;
    if (start > 0 && this.slides[start]) this.track.scrollLeft = this.slides[start].offsetLeft;
    this.index = -1;
    this.setActive(start);
  };

  // Deslizar con el mouse en computadora (en celular el navegador ya desliza con el dedo)
  Product.prototype.initDrag = function () {
    var self = this;
    var track = this.track;
    var drag = null;
    var suppressClick = false;

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || self.slides.length < 2) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true;
        track.classList.add('is-dragging');
        try {
          track.setPointerCapture(drag.id);
        } catch (err) {}
      }
      track.scrollLeft = drag.left - dx;
    });
    function end() {
      if (!drag) return;
      var moved = drag.moved;
      var startLeft = drag.left;
      drag = null;
      if (!moved) return;
      // Se mide antes de reactivar el ajuste por foto, que movería el scroll de regreso
      var width = Math.max(1, track.clientWidth);
      var delta = (track.scrollLeft - startLeft) / width;
      var base = Math.round(startLeft / width);
      // Un arrastre corto basta para pasar a la siguiente foto
      var target = delta > 0.12 ? base + 1 : delta < -0.12 ? base - 1 : base;
      target = Math.max(0, Math.min(self.slides.length - 1, target));
      track.classList.remove('is-dragging');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: target * width, behavior: reduce ? 'auto' : 'smooth' });
      suppressClick = true;
      setTimeout(function () {
        suppressClick = false;
      }, 0);
      self.index = -1;
      self.setActive(target);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener(
      'click',
      function (e) {
        if (!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      },
      true
    );
  };

  Product.prototype.setActive = function (i) {
    if (i === this.index || i < 0 || i >= this.slides.length) return;
    this.index = i;
    if (this.counter) this.counter.textContent = i + 1;
    if (this.progress) this.progress.style.setProperty('--p', ((i + 1) / this.slides.length).toFixed(3));
    this.thumbs.forEach(function (t, n) {
      if (n === i) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    // La miniatura activa se mantiene a la vista; sin animación para no frenar el deslizamiento de la foto
    var active = this.thumbs[i];
    if (active && active.parentElement) {
      var p = active.parentElement;
      var pr = p.getBoundingClientRect();
      var ar = active.getBoundingClientRect();
      if (ar.left < pr.left || ar.right > pr.right) {
        p.scrollLeft += ar.left - pr.left - (pr.width - ar.width) / 2;
      }
    }
    // Pausa los videos que salen de vista
    this.slides.forEach(function (s, n) {
      if (n !== i) {
        var v = s.querySelector('video');
        if (v && !v.paused) v.pause();
      }
    });
  };

  Product.prototype.goTo = function (i, wipe) {
    var slide = this.slides[i];
    if (!slide) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var motion = document.documentElement.getAttribute('data-motion');
    if (wipe && !reduce && motion !== 'none') {
      slide.classList.remove('is-wiping');
      void slide.offsetWidth;
      slide.classList.add('is-wiping');
      setTimeout(function () {
        slide.classList.remove('is-wiping');
      }, 700);
    }
    this.track.scrollTo({ left: slide.offsetLeft, behavior: reduce ? 'auto' : wipe ? 'auto' : 'smooth' });
    this.index = -1;
    this.setActive(i);
  };

  Product.prototype.goToMedia = function (mediaId) {
    var i = this.slides
      ? this.slides.findIndex(function (s) {
          return s.getAttribute('data-media-id') === String(mediaId);
        })
      : -1;
    if (i > -1 && i !== this.index) this.goTo(i, true);
  };

  Product.prototype.openLightbox = function (start) {
    var urls = this.slides
      .map(function (s) {
        return s.getAttribute('data-zoom');
      })
      .filter(Boolean);
    if (!urls.length) return;
    var box = document.getElementById('vk-lightbox');
    if (!box) {
      box = document.createElement('div');
      box.id = 'vk-lightbox';
      box.className = 'vk-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Zoom');
      document.body.appendChild(box);
    }
    box.innerHTML =
      '<button type="button" class="vk-icon-btn vk-lightbox__close" data-vk-close aria-label="Cerrar"><svg class="vk-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<div class="vk-lightbox__track">' +
      urls
        .map(function (u) {
          return '<img src="' + u + '" alt="" loading="lazy">';
        })
        .join('') +
      '</div>';
    if (window.vkUI) window.vkUI.openLayer('vk-lightbox');
    var track = $('.vk-lightbox__track', box);
    var img = track.children[Math.min(start, track.children.length - 1)];
    requestAnimationFrame(function () {
      if (img) track.scrollLeft = img.offsetLeft;
    });
  };

  /* ---------- Descripción plegable ---------- */
  Product.prototype.initDescription = function () {
    var desc = $('[data-vk-desc]', this.el);
    var btn = $('[data-vk-desc-toggle]', this.el);
    if (!desc || !btn) return;
    var check = function () {
      if (desc.scrollHeight <= 460) {
        desc.classList.remove('is-clamped');
        btn.hidden = true;
      }
    };
    requestAnimationFrame(check);
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? btn.getAttribute('data-less') || 'Ver menos' : btn.getAttribute('data-more') || 'Ver más';
    });
  };

  /* ---------- Barra fija de compra ---------- */
  Product.prototype.initSticky = function () {
    var bar = document.querySelector('[data-vk-sticky-buy]');
    var main = this.form ? $('[data-vk-add]', this.form) : null;
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var self = this;
    var footer = document.querySelector('.vk-footer');
    var mainVisible = true;
    var footerVisible = false;
    function update() {
      var show = !mainVisible && !footerVisible && main.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      var btn = $('[data-vk-sticky-add]', bar);
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      update();
    }).observe(main);
    if (footer)
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      }).observe(footer);
    var add = $('[data-vk-sticky-add]', bar);
    if (add)
      add.addEventListener('click', function () {
        if (self.form.requestSubmit) self.form.requestSubmit(main);
        else main.click();
      });
  };

  function init(scope) {
    $$('[data-vk-product]', scope || document).forEach(function (el) {
      if (el.vkProduct) return;
      el.vkProduct = new Product(el);
    });
  }

  window.vkProduct = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
